import { JsonObject, JsonProperty } from 'json2typescript';
import { CompleteDataPortfolioDataInterface } from '../interfaces/portfolio-data.interface';

@JsonObject('CompleteDataPortfolioData')
export class CompleteDataPortfolioData
  implements CompleteDataPortfolioDataInterface
{
  Agent?: Agent;
  Alias?: string;
  AllowOperations?: AllowOperations;
  AnalysisDate?: string;
  AppropriatenessClientCode?: string;
  AppropriatenessClientCodeView?: string;
  AssetClassDistribution?: any[];
  AssetTypeDistribution?: any[];
  BankCode?: string;
  BenchmarkId?: number;
  BenchmarkName?: any;
  CancelDate?: string;
  ChangingModelPortfolio?: boolean;
  ContractRelation?: any;
  CostValue?: number;
  Currency?: string;
  CurrencyDistribution?: any[];
  Exonerated?: boolean;
  GlobalCurrency?: string;
  IBAN?: string;
  InitialDate?: string;
  InOutflows?: number;
  InvestmentProfileData?: InvestmentProfileData;
  InvestmentType?: string;
  IsBlocked?: boolean;
  IsOpenPortfolio?: boolean;
  LVD?: string;
  ModelPortfolioCode?: string;
  ModelPortfolioCodeView?: string;
  ModelPortfolioExternalCode?: string;
  ModelPortfolioName?: string;
  Name?: string;
  Nature?: string;
  OnboardingStatus?: string;
  OnboardingStep?: string;
  OnProductionDate?: string;
  Outlier?: boolean;
  OutProfile?: boolean;
  Performance1M?: number;
  Performance1W?: number;
  Performance1Y?: number;
  Performance1YOpen?: number;
  Performance3M?: number;
  Performance3Y?: number;
  Performance5Y?: number;
  PerformanceStartDate?: number;
  PerformanceStartDateAnualized?: number;
  PerformanceYTD?: number;
  PortfolioCode?: string;
  PortfolioCodeView?: string;
  PortfolioHaveComponents?: boolean;
  ProfitLoss?: number;
  ProfitLossGlobalCurrency?: number;
  ProfitLossPercent?: number;
  RatioSharpe?: any;
  RiskProfileOut?: boolean;
  ServiceModelBehavior?: string;
  ServiceModelCode?: string;
  ServiceModelName?: string;
  TrendStrength?: number;
  Type?: string;
  UnrealizedProfitLoss?: number;
  UnrealizedProfitLossPercent?: number;
  Valuation?: number;
  ValuationDate?: string;
  ValuationGlobalCurrency?: number;
  Var1Y95?: number;
  Volatility?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AgentPortfolio')
export class Agent {
  Code?: string;
  Email?: string;
  FullName?: string;
  Phone?: string;
  UserCode?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('AllowOperationsPortfolio')
export class AllowOperations {
  ActivityId?: number;
  AllowBuy?: boolean;
  AllowCancelContribution?: boolean;
  AllowCancelWithdrawal?: boolean;
  AllowChangeModelPortfolio?: boolean;
  AllowContribution?: boolean;
  AllowProposals?: boolean;
  AllowSell?: boolean;
  AllowWithdrawal?: boolean;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('InvestmentProfileDataPortfolio')
export class InvestmentProfileData {
  ProfileId?: string;
  ProfileName?: string;
  ProfileScore?: number;
  ProfileTestId?: string;
  ProfileTestSignatureStatus?: any;
  ProfileTestSignatureType?: any;
  TestDate?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
